export default "__VITE_ASSET__CbBmyPhn__"